import MarketingShell from '../components/MarketingShell';

export default function Support() {
  return (
    <MarketingShell>
      <section className="mk-section mk-section-tight">
        <div className="mk-split">
          <div className="mk-info-card">
            <h3>Support</h3>
            <p>Email support with same-business-day response for design partners during private beta.</p>
            <p><a href="mailto:support@transformax.app">support@transformax.app</a></p>
          </div>
          <div className="mk-info-card">
            <div className="mk-faq-item mk-faq-first"><b>How do I get access?</b><span>Transformax is invitation-only during private beta. Request an invitation from the home page and we&apos;ll be in touch within a few business days.</span></div>
            <div className="mk-faq-item"><b>I already have an invite — how do I sign in?</b><span>Use the sign-in link from your invitation email, or choose Sign in from any page and enter the work email we invited.</span></div>
            <div className="mk-faq-item"><b>Does Rex work with our platform?</b><span>Rex is platform-agnostic; Platform KB adds grounding for SAP, Dynamics 365, Manhattan, and Oracle Fusion.</span></div>
          </div>
        </div>
      </section>
    </MarketingShell>
  );
}
